export const getMusicAlbumsRoute = () => '/albums';
export const getMusicAlbumCreateRoute = () => '/albums/create';
export const getMusicAlbumEditRoute = (albumId = null) => '/albums/' + (albumId ?? ':albumId');